<script setup lang="ts">
import { useCategorySearch } from "#imports";
import type { Ref } from "vue";
import { getCategoryBreadcrumbs } from "@shopware-pwa/helpers-next";
import { useCmsHead } from "@/composables/useCmsHead";
import type { Schemas } from "#shopware";
import { useCachedCategory } from "~/components/server/useCachedCategory";

const props = defineProps<{
  navigationId: string;
}>();
const { apiClient } = useShopwareContext();

const { search } = useCategorySearch();
const route = useRoute();

const categoryResponse = ref();
categoryResponse.value = await useCachedCategory(
    props.navigationId,
    route.query
);

if (!categoryResponse.value) {
  console.error(
      "[FrontendNavigationPage.vue]",
      "Category could not be found or loaded."
  );
  throw createError({
    statusCode: 404,
    statusMessage: `Category could not be found or loaded.`,
  });
}

const { category } = useCategory(categoryResponse as Ref<Schemas["Category"]>);

const runtimeConfig = useRuntimeConfig();
useCmsHead(category, { mainShopTitle: runtimeConfig.public.general.shopTitle });

const {getAbsoluteUrl}=useAbsoluteUrl();
useHead({
  link: [
    {
      rel: 'canonical',
      href: getAbsoluteUrl(route.path),
    },
  ]
});

</script>

<template>
  <div class="navigation-page">
    <LayoutBreadcrumbs v-if="route.path != '/' && route.path != '/fr-FR'" />
    <CmsPage v-if="category?.cmsPage" :content="category.cmsPage" />
  </div>
</template>
